import { createContext, useContext, useState } from 'react';

const SEOContext = createContext();

export const SEOProvider = ({ children }) => {
  const [dynamicSEO, setDynamicSEO] = useState({});
  
  return (
    <SEOContext.Provider value={{ dynamicSEO, setDynamicSEO }}>
      {children}
    </SEOContext.Provider>
  ); 
};

export const useSEO = () => useContext(SEOContext);